/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'

import Menu from '../../../components/Menu'

import 'react-modern-calendar-datepicker/lib/DatePicker.css'
import DatePicker from '@taak/react-modern-calendar-datepicker'

import { post } from '../../../services/http'
import { notify } from '../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { UserDate } from '../../../Data'

import foodIcon from '../../../assets/svg/orderIcon.svg'
import Table from '../../../components/OrderList/'
import { ToRial } from '../../../services/toRial'

import LineChart from '../../../components/Chart/LineChart'

export default function index() {
  document.title = 'لیست سفارشات'

  const [orders, setOrders] = useState([])
  const [ordersCount, setOrdersCount] = useState(0)
  const [ordersTotal, setOrdersTotal] = useState(0)
  const [selectedDay, setSelectedDay] = useState(0)
  const [selectedDayEnd, setSelectedDayEnd] = useState(0)

  const token = localStorage.getItem('token')

  const [chartData, setChartData] = useState({
    labels: UserDate.map((data) => data.yaer),
    datasets: [
      {
        label: 'فروش هفتگی',
        data: UserDate.map((data) => data.userGain),
        backgroundColor: ['#1B629D'],
      },
    ],
  })

  const searchBtnHandler = () => {
    post(`/api/admin/order/searchdate/?token=${token}`, {
      date: selectedDay,
      dateEnd: selectedDayEnd
    })
    .then(response => {
      setOrders(response.data.data)
      setOrdersCount(response.data.data.length)
      let totlalOrder = 0
      let data = []
      let labels = []
      response.data.data.map(item => {
        return totlalOrder += item.total
      })
      response.data.data.map(item => {
        labels.push(item.createdAt)
        data.push(item.total)
      })
      let datasets = [
        {
          label: 'فروش',
          data,
          backgroundColor: ['#1B629D'],
        },
      ]
      setOrdersTotal(totlalOrder)
      setChartData({ labels, 
        datasets: datasets
      })
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'analyticorder'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={foodIcon} alt='foodIcon' />
              </div>
              <div className='text'>
                سفارشات
              </div>
            </div>

            <div className="left">
            </div>
          </div>

          <div className="tablePart">
            <div className='search'>
              <label htmlFor="search">بازه تاریخ : </label>
              <DatePicker
                value={selectedDay}
                onChange={setSelectedDay}
                shouldHighlightWeekends
                locale="fa" // add this
              />
              <DatePicker
                value={selectedDayEnd}
                onChange={setSelectedDayEnd}
                shouldHighlightWeekends
                locale="fa" // add this
              />
              <button onClick={searchBtnHandler}>جستجو</button>
            </div>
            <hr />

            <div className="statistics">
              <div className='card'>
                <div className='title'>
                  تعداد فروش :
                </div>
                <div className='value'>
                  {ordersCount} عدد
                </div>
              </div>
              <div className='card'>
                <div className='title'>
                  مبلغ فروش :
                </div>
                <div className='value'>
                  {ToRial(String(Math.floor(ordersTotal)))} تومان
                </div>
              </div>
              <div className='card'>
                <div className='title'>
                  بازه تاریخ :
                </div>
                <div className='value'>
                  <span style={selectedDay === 0 ? { display: 'none' } : { display: '' }}>{selectedDay.year}/{selectedDay.month}/{selectedDay.day}</span> - <span style={selectedDayEnd === 0 ? { display: 'none' } : { display: '' }}>{selectedDayEnd.year}/{selectedDayEnd.month}/{selectedDayEnd.day}</span>
                </div>
              </div>
            </div>

            <div className='analytics'>
              <div className='lineChart' style={{ width: '100%', height: '350px' }}>
                <LineChart chartData={chartData} />
              </div>
            </div>

            <Table data={orders} />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
